<p-dataView #dv [lazyLoadOnInit]="true"  [value]="data" [layout]="layout" [lazy]="true" [paginator]="true" [rows]="rows"
    [totalRecords]="totalRecords" (onLazyLoad)="loadData($event)" [first]="first">
    
    <ng-template class="card-header text-center" pTemplate="header">
        <div class="d-flex justify-content-between">
            <span>
                <input [(ngModel)]="date" (input)="filterByDate($event)"  type="date"
                    pInputText class="form-control" >
                <!-- <p-calendar [formControl]="searchControl" [pKeyFilter]="dateFilter" type="Date"
                  placeholder="Search by date..."></p-calendar> -->
            </span>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input [formControl]="searchControl" [pKeyFilter]="keyFilter" [placeholder]="'Search ...'" type="text"
                    pInputText class="form-control" placeholder="Search...">
            </span>
        </div>
    </ng-template>

    <ng-template let-d pTemplate="listItem">
        <div style="border: none !important;" class="grid grid-nogutter">
             @for (d of data; track $index) {
                <ng-container [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{item : d}"></ng-container>
            } 
        </div>
    </ng-template>
    <ng-template pTemplate="empty">
        No Data Found
    </ng-template>
    
    <ng-template pTemplate="footer">
      
        <div class="mb-3 d-flex justify-content-end"><b class="pr-2 pt-1"> Total :</b><h4> {{totalRecords}}</h4></div>
    </ng-template>
</p-dataView>
